export default "__VITE_ASSET__BB7$e9jg__"